import axios from "axios";

export const AboutServices = async (values,pageNum) => {
    const url = `${process.env.REACT_APP_API_URL}/home/about-us?limit=${pageNum}`;
    let  data   = await axios.get(url, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'application/json',
            'Accept-Language': values,
        }
    }).catch((err) => {
    })
    return data
};
export default AboutServices 